import { contractServices } from '@/services'
import { store } from '@/store'
import { contractApi } from '@/store/services'
import { defer, redirect } from 'react-router-dom'
import { list } from '../utils'

export const ContractListLoader = ({ request }) => {
  const url = new URL(request.url)
  const searchParams = new URLSearchParams(url.searchParams)
  const currentPage = Number(searchParams.get('page'))
  const perPage = Number(searchParams.get('per_page'))

  if (!currentPage || !perPage) {
    const defaultSearchParams = new URLSearchParams([
      ['page', '1'],
      ['per_page', '10']
    ])
    const path = list('contracts') + `?${defaultSearchParams}`

    return redirect(path)
  }

  return defer({
    contracts: store
      .dispatch(
        contractApi.endpoints.getParentsContracts.initiate(
          `?${searchParams}`,
          {}
        )
      )
      .unwrap()
  })
}

export const ContractLoaders = Object.freeze({
  create: () => {
    return []
  },

  edit: ({ params: { id } }) => {
    return Promise.all([
      // editMode
      contractServices.show({ id })
    ])
  }
})
